import type { Circular } from '@/lib/types';

// Titles and categories are the client-approved ones from the current notice
// board. Three circulars now have the client's real file; the rest do not exist
// yet, so they keep a "#" link and a PLACEHOLDER date, marked below.
//   - isNew is false everywhere so the page matches the reference design
//     (the design never draws the "New" badge; the component supports it)
const base = { pdfUrl: '#', isNew: false } as const;

export const MOCK_CIRCULARS: Circular[] = [
  // Real file (the client's .docx converted to PDF). Date = the "2 Oct 26" in its filename.
  {
    ...base, id: 'c4', title: 'Members of the Managing Committee 2025–2027', category: 'governance',
    publishedAt: '2026-10-02', pdfUrl: '/files/circulars/managing-committee-2025-27.pdf', fileSizeBytes: 191537,
  },
  // PLACEHOLDER dates: no exam circular files received yet. c1 is pinned to show the Pinned area.
  { ...base, id: 'c1', title: 'Exam Circular — November 2026', category: 'examination', publishedAt: '2026-09-18', isPinned: true },
  { ...base, id: 'c2', title: 'Exam Circular — February 2026 session', category: 'examination', publishedAt: '2026-01-12' },
  // Real file. Date = when the PDF was created (7 Jan 2026); it is signed by the Hon. General Secretary.
  {
    ...base, id: 'c10', title: 'List of holidays 2026', category: 'office',
    publishedAt: '2026-01-07', pdfUrl: '/files/circulars/holiday-list-2026.pdf', fileSizeBytes: 91909,
  },
  { ...base, id: 'c5', title: 'Exam Circular — November 2025 session', category: 'examination', publishedAt: '2025-09-15' },
  // Real file. Date = "Current Issue Date" printed on the certificate.
  // The copy supplied shows an expiry of 22 Aug 2026: ask the client for the current one.
  {
    ...base, id: 'c3', title: 'UQSR ISO certificate', category: 'certificate',
    publishedAt: '2025-08-07', pdfUrl: '/files/circulars/iso-9001-uqsr.pdf', fileSizeBytes: 626861,
  },
  { ...base, id: 'c6', title: 'ITES Exam Circular — August 2025', category: 'examination', publishedAt: '2025-08-04' },
  { ...base, id: 'c7', title: 'Revised fee chart from April/May 2025', category: 'fees', publishedAt: '2025-04-10' },
  { ...base, id: 'c8', title: 'Exam Circular — April/May 2025 session', category: 'examination', publishedAt: '2025-03-20' },
  { ...base, id: 'c9', title: 'Online exam schedule — February 2025 session', category: 'examination', publishedAt: '2025-01-25' },
];
